<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="close()"> <ion-icon slot="icon-only" name="close"></ion-icon> </ion-button>
    </ion-buttons>
    <ion-title>{{ image.caption || ('saga.attachmenttype.picture' | translate) }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [forceOverscroll]="false" fullscreen="true">
  <div class="image-container">
    <img [src]="image.url | secure | async" alt="{{ 'loading...' | translate }}" />
  </div>
</ion-content>
